import api from './api';

export const organizationService = {
  getCurrentOrganization: async () => {
    const response = await api.get('/api/dispatcher/organization/current');
    return response.data;
  },
};
